import React from 'react';
import axios from 'axios';
import { IdCard, Lock } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const CcRequestFiles = ({ req }) => {
  const { user } = useAuth();
  const isAdmin = ['super_admin', 'gestor'].includes(user?.role);
  const sides = ['frente', 'verso'].filter((s) => req.cc?.[s]);
  if (!sides.length) return null;

  const dl = async (side, original) => {
    try {
      const res = await axios.get(`${API_URL}/signature-requests/${req.id}/cc/${side}`, { params: { original }, responseType: 'blob' });
      const cd = res.headers['content-disposition'] || '';
      const m = cd.match(/filename\*=UTF-8''([^;]+)/);
      const a = document.createElement('a');
      a.href = URL.createObjectURL(res.data);
      a.download = m ? decodeURIComponent(m[1]) : `CC_${side}`;
      a.click();
    } catch {
      toast.error('Falha ao descarregar');
    }
  };

  return (
    <div className="flex flex-wrap gap-1 mt-1">
      {sides.map((s) => (
        <React.Fragment key={s}>
          <button type="button" onClick={() => dl(s, false)} className="text-[10px] px-1.5 py-0.5 rounded bg-indigo-50 text-indigo-700 flex items-center gap-1" data-testid={`cc-dl-${s}-${req.id}`}>
            <IdCard className="w-3 h-3" /> CC {s}
          </button>
          {isAdmin && (
            <button type="button" onClick={() => dl(s, true)} className="text-[10px] px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 flex items-center gap-1" title="Original sem marca de água (só Super Admin/Gestor)" data-testid={`cc-dl-orig-${s}-${req.id}`}>
              <Lock className="w-3 h-3" /> Original {s}
            </button>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
